import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStickyNote } from '@fortawesome/free-solid-svg-icons';

const PluginNotesIcon = (props) => {
    const { noteText, onClickBehavior } = props;

    if (isNullOrWhiteSpace(noteText)) {
        return (
            <FontAwesomeIcon
                icon={faStickyNote}
                className="options-icon invalid-icon"
                title="Notes"
            />
        );
    }

    return (
        <FontAwesomeIcon
            icon={faStickyNote}
            className="options-icon notes-icon"
            title="Notes"
            onClick={() => onClickBehavior(noteText)}
        />
    );
};

const isNullOrWhiteSpace = (str) => {
    return str === null || str.match(/^ *$/) !== null;
};

export default PluginNotesIcon;
